import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
// import axios from 'axios';

// components

export class Header extends Component  {
  state = { }

  componentDidMount() {
  }

  topOfContent = () => {
    let form = document.querySelector('#main');
    const y = form.offsetTop - 25;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    })
  }

  navToggle = () => {
    const navCont = document.querySelector('.slidingNav');
    const navBttn = document.querySelector('.hamburger');
    navCont.classList.toggle('open');
    navBttn.classList.toggle('open');
  }

  render() {
    // const { mobileMenu } = this.state;
    // console.dir(this.state);

    return (
      <>
        <button onClick={this.topOfContent} className="screen-reader-shortcut"> Skip to main content</button>

        <header>

          <section className="site-header">
            <div className="container-full">

              <div className="row">
                <div className="col-1 button">
                  <div className="hamburger" onClick={this.navToggle}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                  </div>
                </div>

                <div className="col-2 branding">
                  <a href="/"> <img src={process.env.PUBLIC_URL + '/global/images/logos/usa-logo-whitesm.png'} alt="University of St. Augustine for Health Sciences" /> </a>
                </div>

                <div className="col-1 button">
                  <i className="fa fa-search"></i>
                </div>
              </div>
            </div>
          </section>

        </header>
      </>
    );
  }
}

export default Header;